import React, { Component } from 'react';
import { Grid, Cell } from 'react-md';
import './index.scss';

class Intro extends Component {
    state = {  }
    render() {
        return (
           <section className="intro-wrapper">
                <div className="-text-wrapper">
                    <h2 className="-section-header">
                        تصميم مواقع الإنترنت والهوية التجارية
                    </h2>
                    <p className="-section-descr">
                        تصميم التجربة الرقمية للمستخدم كحجر أساس لكل مشروع وتصميم واجهة المستخدم للتطبيقات حتى التسليم إلى فريق من المطورين
                    </p>
                </div>
                <Grid className="-features hide">
                    <Cell size={4}>6</Cell>
                    <Cell size={4}>4</Cell>
                    <Cell size={4}>2</Cell>
                </Grid>
           </section> 
        );
    }
}

export default Intro;


// WEBPACK FOOTER //
// ./src/components/HomeContainer/Intro/index.jsx